import { Component, OnDestroy, OnInit } from '@angular/core';
import { BreadCrumb } from './breadcrumb.model';
import { combineLatest, merge, Subscription } from 'rxjs';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { AppMode, CurrentContextService } from '@shared/services/currentContextService';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { HubMode } from '@shared/models';

@Component({
  selector: 'breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadCrumbsComponent implements OnInit, OnDestroy {
  breadcrumbs: BreadCrumb[] = [];
  private contextSub: Subscription;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private _currentContext: CurrentContextService, private _currentHub: CurrentHubService) {}

  ngOnInit(): void {
    combineLatest([this._currentContext.appMode$, this._currentHub.hubObservable, this._currentContext.learnspace$, this._currentContext.course$]).subscribe(
      ([mode, hub, learnspace, course]) => {
        const crumbs: BreadCrumb[] = [];

        if (hub && mode !== 'account') {
          crumbs.push(new BreadCrumb(hub.title, () => this.router.navigate([hub?.urlTitle])));
        }
        if (learnspace) {
          const crumbAction = () => this.router.navigate([hub?.urlTitle, learnspace.id]);
          crumbs.push(new BreadCrumb(learnspace.title, crumbAction));
        }

        if (course) {
          const editModeURLPart = this._currentHub.getHubMode() === HubMode.program ? 'simulations' : 'courses';
          const courseEditUrl = mode === 'analytics' ? [hub.urlTitle, learnspace?.id, editModeURLPart, course?.id] : null;
          const crumbAction = courseEditUrl ? () => this.router.navigate(courseEditUrl) : null;
          crumbs.push(new BreadCrumb(course.title, crumbAction));
        }
        switch (mode) {
          case 'analytics':
            crumbs.push(new BreadCrumb('Analytics', null));
            break;
          case 'account':
            crumbs.push(new BreadCrumb('Account Settings', null));
            break;
          default:
            break;
        }
        this.breadcrumbs = crumbs;
      }
    );
  }

  ngOnDestroy(): void {
    this.contextSub?.unsubscribe();
  }

  navigate(crumb: BreadCrumb): void {
    if (crumb.action) {
      crumb.action.call(this);
    }
  }
}
